import { initializeApp } from 'firebase/app';
import { ReCaptchaV3Provider, initializeAppCheck } from "firebase/app-check";
import { connectAuthEmulator, getAuth } from "firebase/auth";

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

const fire = initializeApp(firebaseConfig, "Main");

let authEmulatorConnected = false;

function shouldUseAuthEmulator() {
	return (
		process.env.NODE_ENV === "development" &&
		process.env.REACT_APP_USE_AUTH_EMULATOR === "true"
	);
}

function getAuthEmulatorUrl() {
	const host = process.env.REACT_APP_AUTH_EMULATOR_HOST || "127.0.0.1";
	const port = process.env.REACT_APP_AUTH_EMULATOR_PORT || "9099";
	return `http://${host}:${port}`;
}

const auth = getAuth(fire);

if (!authEmulatorConnected && shouldUseAuthEmulator()) {
	connectAuthEmulator(auth, getAuthEmulatorUrl(), { disableWarnings: true });
	authEmulatorConnected = true;
}

if (typeof window !== "undefined") {
	const appCheckSiteKey = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;
	if (appCheckSiteKey) {
		const debugToken = process.env.REACT_APP_APP_CHECK_DEBUG_TOKEN;
		if (
			(window.location.hostname === "localhost" ||
				window.location.hostname === "127.0.0.1") &&
			debugToken
		) {
			window.FIREBASE_APPCHECK_DEBUG_TOKEN =
				debugToken === "true" ? true : debugToken;
		}

		try {
			initializeAppCheck(fire, {
				provider: new ReCaptchaV3Provider(appCheckSiteKey),
				isTokenAutoRefreshEnabled: true,
			});
		} catch (_error) {
			// Ignore repeated initialization during hot reload.
		}
	}
}

export default fire;
